<template>
    <div class="vertical-bar-chart-container">
        <canvas ref="chart"></canvas>
    </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default {
    name: 'VerticalBarChart',
    props: {
        labels: {
            type: Array,
            required: true,
        },
        datasets: {
            type: Array,
            required: true,
            // Expected format: [{ label: 'Dataset 1', data: [...], color: '#4A3AFF' }]
        },
        groupedBars: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            chart: null,
        }
    },
    watch: {
        datasets: {
            deep: true,
            handler() {
                this.updateChart()
            },
        },
        labels() {
            this.updateChart()
        },
    },
    mounted() {
        this.createChart()
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy()
        }
    },
    methods: {
        createChart() {
            const ctx = this.$refs.chart.getContext('2d')

            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: this.labels,
                    datasets: this.buildDatasets(),
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            backgroundColor: '#1E1B39',
                            titleColor: '#FFF',
                            bodyColor: '#FFF',
                            padding: 10,
                            cornerRadius: 8,
                        },
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            grid: {
                                color: 'rgba(229, 229, 239, 0.15)',
                                drawBorder: false,
                            },
                            ticks: {
                                color: '#FFF',
                                font: {
                                    family: 'Inter',
                                    size: 14,
                                },
                                callback: (value) => {
                                    if (value >= 1000) {
                                        return `${value / 1000}K`
                                    }
                                    return value
                                },
                            },
                        },
                        x: {
                            grid: {
                                display: false,
                            },
                            ticks: {
                                color: '#FFF',
                                font: {
                                    family: 'Inter',
                                    size: 14,
                                },
                            },
                        },
                    },
                },
            })
        },
        buildDatasets() {
            return this.datasets.map((dataset, index) => {
                const bgColor = dataset.backgroundColor || dataset.color || '#4A3AFF'
                return {
                    label: dataset.label,
                    data: dataset.data,
                    backgroundColor: bgColor,
                    borderColor: bgColor,
                    borderWidth: 0,
                    borderRadius: 8,
                    barThickness: 18,
                    categoryPercentage: 0.7,
                    barPercentage: 0.85,
                }
            })
        },
        updateChart() {
            if (this.chart) {
                this.chart.data.labels = this.labels
                this.chart.data.datasets = this.buildDatasets()
                this.chart.update()
            }
        },
    },
}
</script>

<style scoped>
.vertical-bar-chart-container {
    width: 100%;
    height: 250px;
    position: relative;
}
</style>
